module.exports = __webpack_public_path__ + "media/images/page/pause_ic-6da6a5941e7e511145513331c88cccc4.svg";